import React, {useEffect} from 'react';

import { reducer, initialSettingsState, APPLY_TYPE } from "./reducer"
import SettingsService from "../../services/SettingService";

export const SettingsContext = React.createContext({
    ...initialSettingsState,
    dispatch: () => null
})

export const GlobalSettingsStore = ({ children }) => {
    const [settings, dispatch] = React.useReducer(reducer, initialSettingsState, undefined)

    const loadSettings = () => {
        SettingsService.get(
            settings => {
                dispatch({ type: APPLY_TYPE, payload: settings });
            },
            () => {}
        )
    }

    useEffect(() => {
        loadSettings();
    }, []);

    return (
        <SettingsContext.Provider value={[ settings, dispatch ]}>
            { children }
        </SettingsContext.Provider>
    )
}

